/*
  "yyyy-mm-dd" format is always treated as UTC date
  while "yyyy/mm/dd" and "yyyy.mm.dd" are treated as local date
  when we format "yyyy-mm-dd" dates they get converted to local and we get incorrect values
  we should avoid conversion and treat such dates as local by default
*/
export const normalizeToLocalDate = (date: string) =>
  /^\s*\d{4}-\d{2}-\d{2}\s*$/.test(date) ? date.replace(/-/g, '/') : date;

export const currentDate = () => new Date();

export const currentYear = () => new Date().getFullYear();

export const currentMonth = () => new Date().getMonth();

export const currentDateTimeISO = () => new Date().toISOString();

export const currentTimestamp = () => Date.now();

export const currentUnixSeconds = () => Math.trunc(Date.now() / 1000);

export const copyDate = (date: Date) => new Date(date);

export const dateFromTimestamp = (timestamp: number) => new Date(timestamp);

export const timestampToDateTimeISO = (timestamp: number) =>
  new Date(timestamp).toISOString();

export const parseDate = (date: string) => new Date(date);

export const parseToTimestamp = (date: string) => Date.parse(date);

export const parseToUnixSeconds = (date: string) =>
  Math.trunc(Date.parse(date) / 1000);

export const constructDate = (
  ...args: [
    year: number,
    monthIndex: number,
    date?: number,
    hours?: number,
    minutes?: number,
    seconds?: number,
    ms?: number,
  ]
) => new Date(...args);
